var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.visible,
      width: 600,
      height: 760,
      title: _vm.$t("设置")
    },
    on: {
      cancel: _vm.handleCancel
    }
  }, [_c("template", {
    slot: "footer"
  }, [_c("a-button", {
    key: "back",
    on: {
      click: _vm.reset
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("恢复默认")) + " ")]), _c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.seletedQuentity < 7,
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")])], 1), _c("div", {
    staticClass: "container"
  }, [_c("p", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("最少选择7个，最多选择11个显示字段，当前已选")) + _vm._s(_vm.seletedQuentity) + "/11")]), _c("div", {
    staticClass: "list-content"
  }, [_c("a-row", _vm._l(_vm.listData, function (item) {
    return _c("a-col", {
      key: item.id,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        span: 8
      }
    }, [_c("span", {
      staticClass: "label-class",
      attrs: {
        title: _vm.$t(item.titleName)
      }
    }, [_vm._v(_vm._s(_vm.$t(item.titleName)))]), _c("a-switch", {
      attrs: {
        disabled: item.isDefaultLock || item.isLock
      },
      on: {
        change: e => _vm.switchChange(e, item)
      },
      model: {
        value: item.isSelected,
        callback: function ($$v) {
          _vm.$set(item, "isSelected", $$v);
        },
        expression: "item.isSelected"
      }
    }, [item.isDefaultLock ? _c("a-icon", {
      attrs: {
        slot: "checkedChildren",
        type: "lock"
      },
      slot: "checkedChildren"
    }) : _vm._e()], 1)], 1);
  }), 1)], 1)])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };